import {takeLatest} from 'redux-saga/effects';
import {TOGGLE_MODAL} from '../../actions/Modal/modalActionTypes';
import {makeToggle} from './modalWorkers';

export function* toggleModal() {
    yield takeLatest(TOGGLE_MODAL, makeToggle());
}
